import React, { useEffect, useState } from 'react'
import AppModal from '../../components/common/AppModal'
import AddAccountModal from './AddAccountModal'
import TermsOfServiceModal from './TermsOfServiceModal'
import SpecialAdCategoryModal from './SpecialAdCategoryModal'

const SettingsAdAccountModal = ({
    show,
    platformName = 'Ad Platform',
    onCancel,
    faceBookTOSRetrieval,
    onAcceptOnFacebook,
    selectedCategories = [],
    onToggleCategory,
    onSpecialCategoryConfirm,
    isAccepted,
    accounts = [],
    onAdAccountConfirm,
    onAdAccountCancel,
    onSpecialCategoryCancel,
    onTOSConfirm,
    cancelText = 'Back',
    adAccountConfirmText = 'Add',
    tosConfirmText = 'Continue',
    publishers,
    specialCategoryConfirmText = 'Confirm',
}) => {
    const adAccountTitle = `Select ${platformName} Account`
    const [modalTitle, setModalTitle] = useState(adAccountTitle)
    const [confirmDisabled, setConfirmDisabled] = useState(true)
    const [selectedAccount, setSelectedAccount] = useState(false)

    useEffect(() => {
        if (show?.accountSelection) {
            setModalTitle(`Select ${platformName} Account`)
            setConfirmDisabled(false)
        } else if (show?.tosAccepted) {
            setModalTitle(`Accept ${platformName}’s Terms of Service`)
            setConfirmDisabled(!isAccepted)
        } else if (show?.specialAdCategory) {
            setModalTitle(`Select Special Ad Category`)
            setConfirmDisabled(false)
        }
    }, [show, platformName, isAccepted])

    const handleConfirm = () => {
        if (show?.accountSelection) {
            onAdAccountConfirm(selectedAccount, platformName, publishers)
        } else if (show?.tosAccepted) {
            onTOSConfirm()
        } else if (show?.specialAdCategory) {
            onSpecialCategoryConfirm()
        }
    }

    const confirmText = () => {
        if (show?.accountSelection) return adAccountConfirmText
        if (show?.tosAccepted) return tosConfirmText
        if (show?.specialAdCategory) return specialCategoryConfirmText
    }

    const handleCancel = () => {
        if (show?.accountSelection) {
            onAdAccountCancel(platformName)
        } else if (show?.specialAdCategory) {
            onSpecialCategoryCancel(platformName)
        }
    }

    return (
        <AppModal
            show={show?.accountSelection || show?.tosAccepted || show?.specialAdCategory}
            title={modalTitle}
            size="lg"
            centered={!show?.specialAdCategory}
            dialogClassName={
                show?.specialAdCategory
                    ? 'special-ad-centered'
                    : show?.accountSelection
                      ? 'no-modal-body-padding'
                      : 'tos-modal-square'
            }
            onCancel={handleCancel}
            onConfirm={handleConfirm}
            confirmDisabled={show?.tosAccepted ? !isAccepted : confirmDisabled}
            hideCancelButton={show?.tosAccepted}
            confirmText={confirmText}
            cancelText={() => (show?.accountSelection ? 'Back' : cancelText)}
        >
            {show?.accountSelection && (
                <AddAccountModal
                    accounts={accounts}
                    setSelectedAccount={setSelectedAccount}
                    setConfirmDisabled={setConfirmDisabled}
                />
            )}

            {show?.tosAccepted && (
                <TermsOfServiceModal
                    faceBookTOSRetrieval={faceBookTOSRetrieval}
                    onAcceptOnFacebook={onAcceptOnFacebook}
                    isAccepted={isAccepted}
                />
            )}
            {show?.specialAdCategory && (
                <SpecialAdCategoryModal selectedCategories={selectedCategories} onToggleCategory={onToggleCategory} />
            )}
        </AppModal>
    )
}

export default SettingsAdAccountModal
